/**
 * 运营端 API 配置
 * 所有运营端API使用 /operation-api 前缀区分于普通用户API
 */
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || "http://localhost:3100",
  WECHAT_COMMON_BASE_URL:
    process.env.VITE_API_WECHAT_COMMON_URL || "http://localhost:3000",
  TIMEOUT: 10000,

  // API 端点
  ENDPOINTS: {
    // 员工管理
    STAFF_SERVICE: "/operation-api/v1/staff-management/service-staff",
    STAFF_DETAIL: (id: number) => `/operation-api/v1/staff-management/${id}`,
    STAFF_STATS: "/operation-api/v1/staff-management/stats",
    STAFF_APPROVE: (id: number) =>
      `/operation-api/v1/staff-management/${id}/approve`,
    STAFF_LEAVE: (id: number) =>
      `/operation-api/v1/staff-management/${id}/leave`,
    STAFF_INDEXES: (id: number) =>
      `/operation-api/v1/staff-management/${id}/indexes`,
    STAFF_PROFILE: (id: number) =>
      `/operation-api/v1/staff-management/${id}/profile`,
    STAFF_AVAILABLE: (elderId: number) =>
      `/operation-api/v1/staff-management/available-visit-service-staff?elderId=${elderId}`,
    STAFF_CUSTOMERS_SEARCH:
      "/operation-api/v1/staff-management/customers/search",
    STAFF_CREATE: "/operation-api/v1/staff-management",

    // 客户订单管理
    ELDER_VISIT_RELATIONS:
      "/operation-api/v1/customer-management/elder-visit-relations",
    ASSIGN_ELDER_VISIT_RELATION:
      "/operation-api/v1/customer-management/assign-elder-visit-relation",

    // 增值服务分配管理
    VALUE_ADDED_SERVICE_ORDERS:
      "/operation-api/v1/customer-management/value-added-service-orders",
    ASSIGN_VALUE_ADDED_SERVICE:
      "/operation-api/v1/customer-management/assign-value-added-service",

    // 服务类型管理
    SERVICE_TYPES: "/api/v1/service-types",

    // 访问报告管理
    PENDING_REPORTS: "/operation-api/v1/visit-reports",
    PENDING_REPORT_APPROVE: (id: number) =>
      `/operation-api/v1/visit-reports/${id}/approve`,
    PENDING_REPORT_REJECT: (id: number) =>
      `/operation-api/v1/visit-reports/${id}/reject`,

    // 管理员认证
    ADMIN_WECHAT_LOGIN: "/operation-api/v1/auth/admin/wechat-login",
    ADMIN_QUICK_LOGIN: "/operation-api/v1/auth/admin/quick-login",
    ADMIN_VALIDATE_TOKEN: "/operation-api/v1/auth/admin/validate",

    // 任务调度器
    SCHEDULER_TRIGGER: "/api/v1/scheduler/trigger-auto-schedule",
  },
};

// 导出基础URL常量
export const API_BASE_URL = API_CONFIG.BASE_URL;

export default API_CONFIG;
